export function removeDomain(url, type = "path") {
	if (!url) return "";

	try {
		const parsedUrl = new URL(url);
		return type === "path" ? parsedUrl.pathname : parsedUrl.pathname + parsedUrl.search;
	} catch {
		return url;
	}
}
